<template>
    <div class="recentChat-box">
        <div
            v-if="defaultState === 'more'"
            v-show="!showGroupDetail"
            class="recentDetail"
        >
            <ul class="memberList">
                <div
                    v-for="(item, index) in recentChatList"
                    :key="index"
                    class="main-box"
                >
                    <label
                        v-if="item.uId"
                        class="member"
                        :for="item.id"
                        @change="checkContacts($event, item)"
                    >
                        <label
                            class="checkIcon"
                        ><input
                            :id="item.id"
                            v-model="selectedIdList"
                            type="checkbox"
                            :value="item.id"
                            :disabled="isDisabled(item)"
                        ><i /></label>
                        <Avatar :user="item" class="avatar" />
                        <div class="detail contact">
                            <p class="name">
                                <span class="name-flex">{{ item.name }}</span>
                                <span
                                    class="account"
                                >({{ item.lxAccount }})</span>
                            </p>
                            <p class="position">
                                {{ item.job }}
                            </p>
                        </div>
                    </label>
                    <div
                        v-else-if="groupSelectType === 0"
                        class="member"
                        @click="openGroupDetail(item)"
                    >
                        <span @click.stop="">
                            <label
                                class="checkIcon"
                                :for="item.targetId"
                                @change="checkGroups($event, item)"
                            >
                                <input
                                    :id="item.targetId"
                                    v-model="selectedGroupIdList"
                                    type="checkbox"
                                    :value="item.targetId"
                                    :isHalf="isHalf(item)"
                                >
                                <i />
                            </label>
                        </span>
                        <GroupAvatar :group="item" class="avatar" />
                        <div class="detail group">
                            <p class="name">
                                <span class="name-flex">{{ item.name }}</span>
                                <span
                                    class="group-count"
                                >({{ item.memberCount }})</span>
                            </p>
                        </div>
                        <img
                            src="@/assets/images/contacts/arrow-right.png"
                            alt=""
                            class="expandIcon"
                        >
                    </div>
                    <label
                        v-else
                        class="member"
                        :for="item.targetId"
                        @change="checkGroups($event, item)"
                    >
                        <label
                            class="checkIcon"
                        ><input
                            :id="item.targetId"
                            v-model="selectedGroupIdList"
                            type="checkbox"
                            :value="item.targetId"
                            :isHalf="isHalf(item)"
                        ><i /></label>
                        <GroupAvatar :group="item" class="avatar" />
                        <div class="detail group">
                            <p class="name">
                                <span class="name-flex">{{ item.name }}</span>
                                <span
                                    class="group-count"
                                >({{ item.memberCount }})</span>
                            </p>
                        </div>
                    </label>
                </div>
            </ul>
        </div>
        <div
            v-if="defaultState === 'more'"
            v-show="showGroupDetail"
            class="groupDetail"
        >
            <div ref="groupTitle" class="group-title" @click="backToRecent()">
                <img
                    src="@/assets/images/contacts/arrow_right_contacts.png"
                    alt=""
                    class="arrow"
                >
                <span class="name">{{ groupDetail.name }}</span>
            </div>
            <div ref="recentChatBox" class="group-member">
                <label v-show="groupMemberList.length > 0" class="allCheck">
                    <label class="checkIcon">
                        <input
                            :id="groupDetail.targetId"
                            v-model="selectedGroupIdList"
                            type="checkbox"
                            :value="groupDetail.targetId"
                            :isHalf="isHalf(groupDetail)"
                            @change="checkGroups($event, groupDetail)"
                        >
                        <i />
                    </label>
                    <span>全选</span>
                </label>
                <div
                    v-for="(item, index) in groupMemberList"
                    :key="index"
                    class="main-box"
                >
                    <!--这里id/for用lxAccount，因为myDept用了id，如果这里也用id，点击这里的input，会触发myDept的label-->
                    <label
                        class="member"
                        :for="item.lxAccount"
                        @change="checkContacts($event, item)"
                    >
                        <label
                            class="checkIcon"
                        ><input
                            :id="item.lxAccount"
                            v-model="selectedIdList"
                            type="checkbox"
                            :value="item.id"
                            :disabled="isDisabled(item)"
                        ><i /></label>
                        <Avatar :user="item" class="avatar" />
                        <div class="detail contact">
                            <p class="name">
                                <span class="name-flex">{{ item.name }}</span>
                                <!--文件小助手不显示account-->
                                <span
                                    v-if="
                                        item.lxAccount !==
                                            configer.fileTransferRobotId
                                    "
                                    class="account"
                                >({{ item.lxAccount }})</span>
                            </p>
                            <p class="position">
                                {{ item.job }}
                            </p>
                        </div>
                    </label>
                </div>
            </div>
        </div>
        <div v-if="defaultState === 'loading'" class="org-status">
            <img
                src="https://s1.longfor.com/image/40348b3e1ff6aa6833902accafcc0c4f.gif"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                加载中
            </p>
        </div>
        <div v-if="defaultState === 'none'" class="org-status">
            <img
                src="../../../assets/images/contacts/org-window-empty-bg.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                您没有交圈会话
            </p>
        </div>
        <div v-if="defaultState === 'dataLoadingFailed'" class="org-status">
            <img
                src="@/assets/images/contacts/data_loading_failed.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                数据加载失败，请重试
            </p>
            <div class="status-reload">
                <button type="button" class="reload" @click="reload()">
                    重新加载
                </button>
            </div>
        </div>
        <div v-if="defaultState === 'serviceAbnormal'" class="org-status">
            <img
                src="@/assets/images/contacts/service_abnormal.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                服务异常，请联系IT报事
            </p>
            <div class="status-reload">
                <button type="button" class="reload" @click="reload()">
                    重新加载
                </button>
            </div>
        </div>
        <div v-if="defaultState === 'networkAbnormal'" class="org-status">
            <img
                src="@/assets/images/contacts/network_abnormal.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                当前网络不可用，请检查网络设置
            </p>
            <div class="status-reload">
                <button type="button" class="reload" @click="reload()">
                    重新加载
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { getRecentList, getGroups } from '@/apis/contactsWindow/contactsWindow'
import Avatar from '@/components/Avatar'
import GroupAvatar from '@/components/GroupAvatar'
import { configer } from '@/config'
import contactsConfig from '@/utils/contacts/config'

export default {
    name: 'RecentChat',
    components: {
        Avatar,
        GroupAvatar
    },
    props: {
        selected: {
            type: [Array],
            required: false,
            default: () => []
        },
        countLimit: {
            type: [Number],
            required: true
        },
        isStaff: {
            type: Boolean,
            required: true,
            default: false
        },
        loginRights: {
            type: Object,
            required: true
        },
        defaultSelected: {
            type: [Array],
            required: false,
            default: () => []
        },
        canNotSelected: {
            type: [Array],
            required: false,
            default: () => []
        },
        selectedGroups: {
            type: [Array],
            required: false,
            default: () => []
        },
        selectedHalfGroups: {
            type: [Array],
            required: false,
            default: () => []
        },
        groupSelectType: {
            type: [Number],
            required: true
        },
        conversationType: {
            type: [Number],
            required: true
        }
    },
    data() {
        return {
            recentChatList: [], // 最近聊天list
            defaultState: '',
            groupMembersCache: {},
            groupDetail: {},
            groupMemberList: [],
            showGroupDetail: false,
            configer: configer
        }
    },
    computed: {
        selectedIdList: {
            get() {
                return this.selected.map(item => item.id)
            },
            set() {}
        },
        selectedGroupIdList: {
            get() {
                return this.selectedGroups.map(item => item.id)
            },
            set() {}
        },
        defaultIdList() {
            return (this.defaultSelected || []).map(item => item.id)
        },
        canNotSelectedIds() {
            return this.canNotSelected || []
        },
        // 是否有通讯录权限:-1无权限;0低权限;1高权限
        userLevel() {
            return !this.loginRights.authorityGrade
                ? -1
                : +this.loginRights.authorityGrade
        }
    },
    mounted() {
        setTimeout(() => {
            if (!this.defaultState) {
                this.defaultState = 'loading'
            }
        }, contactsConfig.loadingTimeout)
        this.getRecentChatListData()
    },
    methods: {
        reload() {
            this.defaultState = 'loading'
            this.getRecentChatListData()
        },
        getRecentChatListData() {
            // 获取最近联系人
            const context = this
            context.recentChatList = []
            const temp = {
                conversationType: this.conversationType, // 聊天会话类型("1":单聊；”3“：群聊；"100":单聊和群聊混合)
                count: 50, // 1<=count<=100
                isFileAssistant: context.groupSelectType === 0 ? '0' : '1' // 是否需要文件小助手；默认为0不需要，1为需要
            }
            getRecentList(temp)
                .then(res => {
                    if (res.code === '0') {
                        const recentList = res.data
                        if (recentList.length === 0) {
                            this.defaultState = 'none'
                            return
                        } else {
                            this.defaultState = 'more'
                        }
                        context.recentChatList = this.formatUserData(recentList)
                    } else {
                        context.defaultState = 'dataLoadingFailed'
                    }
                })
                .catch(err => {
                    if (err.message === 'Network Error') {
                        context.defaultState = 'networkAbnormal' // 当前网络不可用，请检查网络设置
                    } else {
                        context.defaultState = 'serviceAbnormal' // 服务异常，请联系IT报事
                    }
                })
        },
        // 格式化从后端获取的数据
        formatUserData(list) {
            const tempList = []
            for (let i = 0; i < list.length; i++) {
                let obj = {}
                // 文件小助手特殊处理
                if (
                    list[i].conversationType === '1' &&
                    list[i].targetId === this.configer.fileTransferRobotId
                ) {
                    list[i].lxAccount = list[i].targetId
                    list[i].name = list[i].title
                }
                if (list[i].conversationType === '1' || list[i].uId) {
                    // list[i].uId这个判断是为了兼容获取群详情里的staffs时format数据
                    obj = {
                        uId: list[i].targetId || list[i].uId || '',
                        id: list[i].targetId || list[i].uId || '',
                        headId: list[i].headId || '',
                        portraitUrl: list[i].portraitUrl || '',
                        name: list[i].name || '',
                        lxAccount: list[i].lxAccount || '',
                        userType: +list[i].userType || '',
                        isExec: +list[i].isExec || 0,
                        job: list[i].job || '',
                        status: 1 // 后端已过滤，默认给1，在职
                    }
                    tempList.push(obj)
                } else if (list[i].conversationType === '3') {
                    obj = {
                        targetId: list[i].targetId || '', // 群组头像用
                        id: list[i].targetId || '', // 给群组一个id,addedGroup、removedGroup需要id
                        name: list[i].title || '',
                        portraitUrl: list[i].portraitUrl || '',
                        memberCount: list[i].memberCount || ''
                    }
                    tempList.push(obj)
                }
            }
            return tempList
        },
        // 点击常用联系人
        checkContacts(event, item) {
            const checked = event.target.checked
            const context = this
            if (checked) {
                if (context.countLimit) {
                    const count = context.selected.length + 1
                    if (count > context.countLimit) {
                        context.$nextTick(() => {
                            // 人数超了不需要选中
                            event.target.checked = false
                        })
                        context.$emit('maxCountLimit')
                        return
                    }
                }
                // 先添加到 selected 列表中
                context.$emit('added', [item])
            } else {
                // 先 remove selected
                context.$emit('removed', [item])
            }
        },
        // 点击常用群聊
        checkGroups(event, groupItem) {
            groupItem.id = groupItem.targetId
            const checked = event.target.checked
            const context = this
            let member = []
            if (checked) {
                // 默认设置false，防止接口异步响应会先选中再取消
                event.target.checked = false
            }
            if (this.groupSelectType === 0) {
                // 是否转发，0选人，1转发选群
                const memberFunc = memberData => {
                    member = this.formatUserData(memberData).filter(val => {
                        return !this.isDisabled(val)
                    })
                    if (checked) {
                        if (context.countLimit) {
                            // 排除已选的群成员
                            const selectedIdList = context.selected.map(
                                item => item.id
                            )
                            const memberCountWithout = member.filter(item => {
                                return selectedIdList.indexOf(item.uId) < 0
                            })
                            const count =
                                context.selected.length +
                                memberCountWithout.length
                            if (count > context.countLimit) {
                                context.$emit('maxCountLimit')
                                return
                            }
                        }
                        addMembers(member, context)
                        context.$emit('addedGroup', [groupItem])
                        // 深拷贝一下，然后把群成员塞进去存一下
                        const group = JSON.parse(JSON.stringify(groupItem))
                        const memberIdList = []
                        for (let i = 0; i < member.length; i++) {
                            if (!this.isDisabled(member[i])) {
                                memberIdList.push(member[i].id)
                            }
                        }
                        group.memberList = memberIdList
                        context.$emit('saveGroupsList', [group])
                        event.target.checked = true
                    } else {
                        // 非转发remove 群里的人
                        context.$emit('removed', member)
                        context.$emit('removedGroup', [groupItem])
                    }
                }
                // 如果有组件缓存数据，使用组件缓存数据
                if (context.groupMembersCache[groupItem.id]) {
                    const memberData = context.groupMembersCache[groupItem.id]
                    memberFunc(memberData)
                    return
                }
                getGroups(groupItem.id)
                    .then(res => {
                        if (res.code === '0') {
                            const memberData = res.data.staffs // 存放群内所有成员的信息
                            context.groupMembersCache[groupItem.id] = memberData
                            memberFunc(memberData)
                        } else {
                            this.$message({
                                message: res.message,
                                type: 'error',
                                duration: 3000
                            })
                            context.$nextTick(() => {
                                // 获取失败不需要选中
                                event.target.checked = false
                            })
                        }
                    })
                    .catch(err => {
                        console.warn(err)
                        context.$message({
                            message: '获取群信息失败',
                            type: 'error',
                            duration: 3000
                        })
                    })
            } else {
                if (checked) {
                    if (context.countLimit) {
                        // 排除已选的群成员
                        const count = context.selected.length
                        if (count > context.countLimit) {
                            context.$emit('maxCountLimit')
                            return
                        }
                        context.$emit('addedGroup', [groupItem])
                        context.$emit('added', [groupItem])
                    }
                } else {
                    // 转发remove整个群
                    context.$emit('removed', [groupItem])
                    context.$emit('removedGroup', [groupItem])
                }
            }
        },
        openGroupDetail(groupItem) {
            const context = this
            if (context.busy) {
                return
            }
            context.busy = true
            const memberFunc = memberData => {
                context.busy = false
                const member = this.formatUserData(memberData)
                context.showGroupDetail = true
                context.$nextTick(() => {
                    // context.$refs.groupTitle.scrollIntoView()
                    context.$refs.recentChatBox.scrollTop = 0
                    context.$emit('checkedHalf')
                })
                context.groupDetail = groupItem
                context.groupMemberList = member
                // 深拷贝一下，然后把群成员塞进去存一下
                const group = JSON.parse(JSON.stringify(groupItem))
                const memberIdList = []
                for (let i = 0; i < member.length; i++) {
                    if (!this.isDisabled(member[i])) {
                        memberIdList.push(member[i].id)
                    }
                }
                group.memberList = memberIdList
                context.$emit('saveGroupsList', [group]) // 把点击过的群信息存到allSelectedGroups里
            }
            // 如果有组件缓存数据，使用组件缓存数据
            if (context.groupMembersCache[groupItem.id]) {
                const memberData = context.groupMembersCache[groupItem.id]
                memberFunc(memberData)
                return
            }
            getGroups(groupItem.targetId)
                .then(res => {
                    if (res.code === '0') {
                        const memberData = res.data.staffs
                        context.groupMembersCache[groupItem.id] = memberData
                        memberFunc(memberData)
                    } else {
                        context.busy = false
                        context.$message({
                            message: res.message,
                            type: 'error',
                            duration: 3000
                        })
                    }
                })
                .catch(err => {
                    context.busy = false
                    console.warn(err)
                    context.$message({
                        message: '获取群信息失败',
                        type: 'error',
                        duration: 3000
                    })
                })
        },
        backToRecent() {
            this.showGroupDetail = false
        },
        isHalf(item) {
            const idList = this.selectedHalfGroups.map(item => item.id)
            return idList.indexOf(item.targetId) > -1
        },
        /* 成员的禁用状态，是否可选择、取消。 1.默认选中成员 */
        isDisabled(item) {
            return (
                this.isDefault(item) ||
                this.executiveLimit(item) ||
                this.isCannotSelected(item)
            )
        },
        isDefault(item) {
            return this.defaultIdList.indexOf(item.id) >= 0
        },
        executiveLimit(item) {
            if (this.isStaff && this.userLevel >= 1) {
                return false
            }
            const isExec = item && !!+item.isExec
            return isExec
        },
        isCannotSelected(item) {
            return this.canNotSelectedIds.indexOf(item.id) >= 0
        }
    }
}
function addMembers(members, context) {
    members = members.filter(item => !context.isDisabled(item))
    // 先给 members 去重
    members = uniq(members)
    members = without(members, context.selected)
    if (members.length > 0) {
        context.$emit('added', members)
    }
}
function uniq(array) {
    const map = {}
    return array.filter(item => {
        const id = item.id
        if (map[id]) {
            return false
        }
        map[id] = id
        return true
    })
}

function without(members, others) {
    const otherIds = others.map(item => item.id)
    return members.filter(item => otherIds.indexOf(item.id) < 0)
}
</script>

<style lang="scss" scoped>
.recentChat-box {
    height: 100%;
    overflow-y: hidden;
    .org-status {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding-bottom: 94px;
        box-sizing: border-box;
        .status-img {
            width: 90px;
            height: 90px;
        }
        .status-text {
            margin-top: 12px;
            font-size: 14px;
            line-height: 22px;
            color: #464646;
        }
        .status-reload {
            width: 180px;
            height: 36px;
            margin-top: 18px;
            .reload {
                width: 100%;
                height: 36px;
                font-size: 14px;
                color: #fff;
                text-align: center;
                line-height: 36px;
                border: 0;
                background: #007af5;
                border-radius: 2px;
                cursor: pointer;
                &:hover {
                    background-color: #006edd;
                }
            }
        }
    }
    .recentDetail {
        height: 100%;
        overflow-y: auto;
    }
    .groupDetail {
        height: 100%;
        display: flex;
        flex-direction: column;
        .group-title {
            height: 36px;
            display: flex;
            align-items: center;
            margin: 0 6px;
            padding: 0 6px;
            border-radius: 4px;
            cursor: pointer;
            &:hover {
                background: rgba(0, 0, 0, 0.04);
            }
            .arrow {
                width: 18px;
                height: 18px;
            }
            .name {
                padding-left: 6px;
                font-size: 14px;
                line-height: 22px;
                color: #323232;
                cursor: pointer;
            }
        }
        .group-member {
            flex: 1;
            overflow-y: auto;
        }
    }
    .checkIcon {
        cursor: pointer;
        display: flex;
        align-items: center;
        input {
            display: none;
            & + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-default.png');
                background-size: 100% 100%;
            }
            &:checked + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-ok.png');
                background-size: 100% 100%;
            }
            &:checked[disabled] + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-no.png');
                background-size: 100% 100%;
            }
            &[disabled] + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-disableno.png');
                background-size: 100% 100%;
            }
            &[isHalf] + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-half.png');
                background-size: 100% 100%;
            }
        }
    }
    .allCheck {
        height: 36px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        border-radius: 4px;
        margin: 0 6px;
        padding: 0 6px;
        cursor: pointer;
        &:hover {
            background-color: #f5f5f5;
        }
        span {
            font-size: 14px;
            line-height: 24px;
            color: #323232;
            margin-left: 12px;
        }
    }
    .member {
        display: flex;
        align-items: center;
        height: 54px;
        border-radius: 4px;
        margin: 0 6px;
        padding: 0 6px;
        cursor: pointer;
        &:hover {
            background: #f5f5f5;
        }
        .avatar {
            width: 36px;
            height: 36px;
            margin: 0 12px;
        }
        .detail.contact {
            flex: 1;
            overflow: hidden;
            .name {
                font-size: 14px;
                line-height: 22px;
                color: #323232;
                overflow: hidden;
                display: flex;
                .name-flex {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    max-width: 115px;
                    padding-right: 6px;
                }
                .account {
                    flex: 1;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
            .position {
                font-size: 12px;
                line-height: 18px;
                color: #999999;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
        .detail.group {
            flex: 1;
            overflow: hidden;
            .name {
                font-size: 14px;
                line-height: 22px;
                color: #323232;
                overflow: hidden;
                display: flex;
                .name-flex {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    max-width: 180px;
                    padding-right: 6px;
                }
                .group-count {
                    flex: 1;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
            .position {
                font-size: 12px;
                line-height: 18px;
                color: #999999;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
        .expandIcon {
            width: 18px;
            height: 18px;
        }
    }
}
</style>
